import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Directive,
  HostBinding,
  Input,
} from '@angular/core';
import { AvatarDirective } from './avatar.directive';
import {
  coerceCssPixelValue,
  coerceNumberProperty,
} from '@angular/cdk/coercion';
import { AvatarComponent } from './avatar.component';

@Directive({
    selector: '[luiAvatarPrimary]',
    standalone: false
})
export class AvatarPrimaryDirective {}

@Directive({
    selector: '[luiAvatarSecondary]',
    standalone: false
})
export class AvatarSecondaryDirective {}

@Component({
    selector: 'lui-dual-avatar',
    templateUrl: './dual-avatar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DualAvatarComponent implements AfterContentInit {
  @Input() get xPosition(): 'start' | 'end' {
    return this._xPosition;
  }
  set xPosition(value: 'start' | 'end') {
    if (value) {
      this._xPosition = value;
      this._setCssVariables();
    }
  }
  _xPosition: 'start' | 'end' = 'end';

  @Input() get yPosition(): 'top' | 'bottom' {
    return this._yPosition;
  }
  set yPosition(value: 'top' | 'bottom') {
    if (value) {
      this._yPosition = value;

      this._setCssVariables();
    }
  }
  _yPosition: 'top' | 'bottom' = 'top';

  @Input() get xOffset(): string {
    return this._xOffset;
  }
  set xOffset(value: string | number) {
    this._xOffset = coerceCssPixelValue(value);
  }

  _xOffset = '50%';

  @ContentChild(AvatarPrimaryDirective, { read: AvatarComponent })
  avatarPrimary!: AvatarComponent;

  // private _height = 0;
  // @HostBinding('style.height.px')
  // get height() {
  //   return this._height;
  // }
  // set height(value) {
  //   this._height = value;
  // }

  // private _width = 0;
  // @HostBinding('style.width.px')
  // get width() {
  //   return this._width;
  // }
  // set width(value) {
  //   this._width = value;
  // }

  @HostBinding('class') hostClass = 'lui-dual-avatar';

  @HostBinding('class.lui-dual-avatar-start') get startClass() {
    return this.xPosition === 'start';
  }
  @HostBinding('class.lui-dual-avatar-end') get endClass() {
    return this.xPosition === 'end';
  }
  @HostBinding('class.lui-dual-avatar-top') get topClass() {
    return this.yPosition === 'top';
  }
  @HostBinding('class.lui-dual-avatar-bottom') get bottomClass() {
    return this.yPosition === 'bottom';
  }

  @HostBinding('style.--x') xCssVariable!: string;
  @HostBinding('style.--y') yCssVariable!: string;

  ngAfterContentInit(): void {
    // const avatarSize = coerceNumberProperty(this.avatarPrimary.size);

    // this._height = avatarSize;
    // this._width = avatarSize;

    this._setCssVariables();
  }

  private _setCssVariables() {
    this.xCssVariable = this.xPosition === 'end' ? '50%' : '-50%';
    this.yCssVariable = this.yPosition === 'top' ? '-50%' : '50%';
  }
}
